import MobileSelect from "../../baseSelect/mobiles/MultiSelect/index.mobile";
import { formatOptions } from "../../helper";
import { generatePairsMobile, restoreOriginalObjectMobile } from "./helper";

type ValueType = {
  region: string[];
  location: string[];
};

type PropsType = {
  location_filter: any[];
  value: ValueType;
  isMulty?: boolean;
  onChange?: (any) => void;
  search_country_text?: string;
  location_text?: string;
  className?: string;
  onFocus?: () => void;
};

function extractChildren(arr) {
  let result = [];
  let level = 0;
  for (let i = 0; i < arr.length; i++) {
    if (arr[i].children && arr[i].children.length === 1) {
      result.push(arr[i].children[0]);
      level = 1;
    } else if (arr[i].children && arr[i].children.length > 1) {
      return { result: arr, level: 0 };
    }
  }
  return { result, level };
}

function LocationSelectMobile({
  location_filter = [],
  value,
  isMulty = true,
  onChange,
  search_country_text,
  location_text,
  className = "",
  onFocus = () => {}
}: PropsType) {
  const options = formatOptions(location_filter, ["locations"]);
  const { result: _options, level } = extractChildren(options);

  const newValue = generatePairsMobile(value, options);

  const restoreProviderValue = (value) => {
    const changeValue = restoreOriginalObjectMobile(value, options);
    if (onChange) {
      onChange(changeValue);
    }
  };

  return (
    <MobileSelect
      placeholder={search_country_text}
      searchTitle={location_text}
      value={newValue}
      isMulty={isMulty}
      options={_options}
      onChange={restoreProviderValue}
      className={className}
      onFocus={onFocus}
    />
  );
}

export default LocationSelectMobile;
